<template>
  <div
    class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-gray-600/50 transition-all ease-in duration-75"
    :class="{
      'opacity-0 invisible pointer-events-none scale-75': !isVisible,
    }"
  >
    <div class="px-10 py-5 bg-white dark:bg-gray-800 rounded-lg w-auto max-h-[90vh] overflow-y-auto">
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">Rejected Speakers</h2>
      <table>
        <thead>
          <tr class="border-b border-gray-200 dark:border-gray-700">
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Speaker Name</th>
            <!-- <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Status</th> -->
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Live Keynote Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">In Conversation Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Virtual Keynote Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Full Day Workshop Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Half Day Workshop Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">MC Half Day Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">MC Full Day Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Campaign Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Other Fee</th>
            <th class="px-4 py-2 text-left text-gray-600 dark:text-gray-300">Education/NFP Fee</th>
          </tr>
        </thead>
        <tbody v-for="(speakerData, index) in rejectedSpeakers">
          <tr :key="index" class="border-b border-gray-200 dark:border-gray-700">
            <td class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ speakerData.speaker.speaker_name }}</td>
            <!-- <td class="px-4 py-2 text-red-600 dark:text-red-400 font-semibold">Rejected</td> -->
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Live_Keynote_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.In_Conversation_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Virtual_Keynote_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Full_Day_Workshop_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Half_Day_Workshop_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.MC_Half_Day_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.MC_Full_Day_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Campaign_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Other_Fee }}</td>
            <td class="px-4 py-2 text-gray-500 dark:text-gray-400">{{ speakerData.fees.Education_NFP_Fee }}</td>
          </tr>
        </tbody>
      </table>
      
      <div v-if="rejectedSpeakers.length === 0" class="text-gray-500 dark:text-gray-400 mt-2">
        No rejected speakers found.
      </div>
      <div class="flex justify-center gap-4 mt-4">
        <button
          @click="cancel"
          class="px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-gray-300 shadow leading-6 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition ease-in-out duration-150"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'ViewRejectedSpeakersModal',
    props: {
      isVisible: {
        type: Boolean,
        required: true
      },
      rejectedSpeakers: {
        type: Array,
        required: true
      }
    },
    emits: ['update:isVisible'],
    methods: {
      cancel() {
        this.$emit('update:isVisible', false);
      }
    }
  };
  </script>